import { BloodOxygen } from "@cur8/health-risks-calc";
import { useQueryParams } from "@pomle/react-router-paths";
import { queries } from "render/routes/paths";
import { toChartRanges } from "render/ui/presentation/RangeChart/lib/risk";
import { MetricDetails } from "render/views/Report/AppointmentDataView/components/MetricsSection/components/layouts/Details";
import { getMetricHistory } from "render/views/Report/AppointmentDataView/components/MetricsSection/components/metrics/utils/getMetricHistory";
import { useBloodOxygenMetric } from "render/views/Report/AppointmentDataView/components/MetricsSection/hooks/usePatientReportMetrics";
import { Trans } from "./trans";

export function MetricBloodOxygenDetails() {
  const [params, setParams] = useQueryParams(queries.metric);
  const { data } = useBloodOxygenMetric();
  const numOfScans = data?.length || 1;

  const scanNum = params.scan[0] || numOfScans;
  const setScanNum = (num: number) =>
    setParams({
      scan: [num],
    });
  const ranges = BloodOxygen.rangesFor();

  if (!data) {
    return undefined;
  }

  const { cur: current, prev: previous } = getMetricHistory(data, scanNum);

  const riskRanges = BloodOxygen.rangesFor();

  const values = {
    subLabel: <Trans.MetricUnit />,
    value: current?.unit["percent"],
    previousValue: previous?.unit["percent"],
    metricRating: current && riskRanges.findRisk({ "%": current.unit.percent }),
    scanDate: current?.measurement.timestampStart,
    ranges: toChartRanges(ranges.entries),
  };

  return (
    <MetricDetails
      label={<Trans.MetricName />}
      values={values}
      scanNum={scanNum}
      setScanNum={setScanNum}
      numOfScans={numOfScans}
      FAQText={Trans.FAQ}
      hideChange
    />
  );
}
